<template>
  <v-container grid-list-lg fluid>
    <v-layout row wrap>
      <dados-rodada />
    </v-layout>

    <v-layout row wrap v-if="tipousuario == 'administrador'">
      <dashboard-administradores />
    </v-layout>

    <v-layout row wrap v-if="tipousuario == 'fornecedor'">
      <dashboard-fornecedores />
    </v-layout>

    <v-layout row wrap v-if="tipousuario == 'representante'">
      <dashboard-representantes />
    </v-layout>
  </v-container>
</template>

<script>
import DadosRodada from "./DadosRodada.vue";
import DashboardAdministradores from "../graficos/GraficosAdministradores.vue";
import DashboardFornecedores from "../graficos/GraficosFornecedores.vue";
import DashboardRepresentantes from "../graficos/GraficosRepresentantes.vue";

export default {
  name: "Dashboard",
  components: {
    DadosRodada,
    DashboardAdministradores,
    DashboardFornecedores,
    DashboardRepresentantes,
  },
  data() {
    return {
      loading: false,
      tipousuario: "",
    };
  },
  mounted() {
    this.tipousuario = this.$auth.user.tipo;
  },
};
</script>
